(() => {
  const groups = [
    ['shelving system', 'reol|reoler|reolen|reolerne|reolsystem|reolsystemer|reolvæg|reolvaeg|bogreol|bogreoler|regal|regale|regalsystem|regalsysteme|bücherregal|buecherregal|bucherregal|bücherregale'],
    ['wall shelving', 'vægreol|vægreoler|vaegreol|vaegreoler|væg reol|wandregal|wandregale'],
    ['magazine shelving', 'magasinreol|magasinreoler|tidsskriftsreol|zeitschriftenregal|zeitschriftenregale'],
    ['shelf', 'hylde|hylder|hylden|hylderne|regalboden|regalböden|regalboeden'],
    ['gallery shelf', 'billedhylde|billedhylder|billedehylde|billedehylder|bilderleiste|bilderleisten'],
    ['cabinet', 'skab|skabe|skabet|schrank|schränke|schraenke|regalskab'],
    ['bed', 'seng|senge|sengen|sengene|sengeramme|sengerammer|sengestel|bett|betten|bettgestell|bettgestelle|bettrahmen'],
    ['expandable bed', 'udtræksseng|udtraeksseng|ausziehbett|ausziehbares bett|erweiterbares bett'],
    ['bed slats', 'lamelbund|lamelbunde|sengelameller|lattenrost|lattenroste'],
    ['bed side table', 'sengebord|sengeborde|natbord|natborde|nachttisch|nachttische|nachtkonsole|nachtkonsolen'],
    ['storage box', 'opbevaringskasse|opbevaringskasser|opbevaringsboks|opbevaringsbokse|trækasse|trækasser|traekasse|traekasser|kasse|kasser|aufbewahrungsbox|aufbewahrungsboxen|aufbewahrungskiste|aufbewahrungskisten|holzkiste|holzkisten|holzbox|holzboxen|kiste|kisten'],
    ['storage', 'opbevaring|aufbewahrung'],
    ['storage tower', 'opbevaringstårn|opbevaringstaarn|kassetårn|kassetaarn|aufbewahrungsturm|aufbewahrungstürme'],
    ['storage chest', 'opbevaringskiste|opbevaringskister|trækiste|traekiste|truhe|truhen|aufbewahrungstruhe'],
    ['lid', 'låg|laag|kasselåg|kasselaag|deckel|holzdeckel'],
    ['wheels', 'hjul|hjulsæt|hjulsaet|rollen|räder|raeder'],
    ['frame', 'ramme|rammer|rammen|billedramme|billedrammer|billederamme|billederammer|fotoramme|fotorammer|plakatramme|plakatrammer|rahmen|bilderrahmen|fotorahmen|posterrahmen'],
    ['standing frame', 'stående ramme|staaende ramme|standrahmen'],
    ['mirror', 'spejl|spejle|spejlet|spejlene|spiegel'],
    ['wall mirror', 'vægspejl|vægspejle|vaegspejl|vaegspejle|væg spejl|wandspiegel'],
    ['standing mirror', 'bordspejl|bordspejle|standspiegel|tischspiegel'],
    ['tall wall mirror', 'langt spejl|højt spejl|hoejt spejl|ganzkörperspiegel|ganzkoerperspiegel'],
    ['table', 'bord|borde|bordet|bordene|tisch|tische'],
    ['dining table', 'spisebord|spiseborde|esstisch|esstische|esszimmertisch'],
    ['coffee table', 'sofabord|sofaborde|couchtisch|couchtische|sofatisch'],
    ['café table', 'cafebord|cafeborde|cafébord|cafébordene|cafétisch|cafetisch|bistrotisch|bistrotische'],
    ['bar table', 'barbord|barborde|bartisch|bartische|stehtisch|stehtische'],
    ['side table', 'sidebord|sideborde|beistelltisch|beistelltische'],
    ['desk', 'skrivebord|skriveborde|schreibtisch|schreibtische'],
    ['fold-out desk', 'klapbord|klapskrivebord|klappschreibtisch|wandschreibtisch'],
    ['chair', 'stol|stole|stolen|stolene|stuhl|stühle|stuehle|spisebordsstol|spisebordsstole|esszimmerstuhl|esszimmerstühle'],
    ['lounge chair', 'lænestol|lænestole|laenestol|laenestole|loungestol|loungestole|sessel|loungesessel'],
    ['bar chair', 'barstol|barstole|barhocker|barstuhl|barstühle'],
    ['bench', 'bænk|bænke|baenk|baenke|bank|bänke|baenke|sitzbank|sitzbänke'],
    ['stool', 'skammel|skamler|taburet|taburetter|hocker|sitzhocker'],
    ['step stool', 'trappestige|trappestol|trappeskammel|tritt|tritthocker|trittschemel'],
    ['modular sofa', 'modulsofa|modulsofaer|modulær sofa|modulaer sofa|modulares sofa|modulsofaen|modularsofa'],
    ['sofa', 'sofaer|sofaen|sofas|couch|couches'],
    ['ottoman', 'puf|puffer|pouf|fusshocker|fußhocker'],
    ['lamp', 'lampe|lamper|lampen|lamperne|leuchte|leuchten'],
    ['lighting', 'belysning|beleuchtung'],
    ['table lamp', 'bordlampe|bordlamper|tischlampe|tischlampen|tischleuchte|tischleuchten'],
    ['wall lamp', 'væglampe|væglamper|vaeglampe|vaeglamper|wandlampe|wandlampen|wandleuchte|wandleuchten'],
    ['pendant', 'pendel|pendler|loftlampe|loftlamper|hængelampe|haengelampe|hængelamper|haengelamper|pendelleuchte|pendelleuchten|pendellampe|pendellampen|hängelampe|haengelampe|hängelampen|haengelampen|deckenlampe|deckenlampen'],
    ['coat rack', 'knagerække|knagerækker|knageraekke|knageraekker|garderobe|garderobenleiste|hakenleiste'],
    ['wall hook', 'knage|knager|knagen|vægkrog|vaegkrog|krog|kroge|wandhaken|kleiderhaken|haken'],
    ['knob', 'knop|knopper|knauf|knäufe|knaeufe'],
    ['toilet roll holder', 'toiletrulleholder|toiletpapirholder|toilettenpapierhalter|toilettenrollenhalter'],
    ['cutting board', 'skærebræt|skærebrætter|skaerebraet|skaerebraetter|schneidebrett|schneidebretter|schneidbrett'],
    ['tray', 'bakke|bakker|serveringsbakke|serveringsbakker|tablett|tabletts|serviertablett'],
    ['coffee cup', 'kop|kopper|kaffekop|kaffekopper|krus|kaffekrus|tasse|tassen|kaffeetasse|kaffeetassen|becher'],
    ['book stand', 'bogholder|bogstøtte|bogstoette|bogstativ|buchständer|buchstaender|buchhalter'],
    ['bottle opener', 'oplukker|flaskeåbner|flaskeaabner|flaschenöffner|flaschenoeffner'],
    ['key ring', 'nøglering|nøgleringe|noeglering|noegleringe|schlüsselring|schluesselring|schlüsselanhänger|schluesselanhaenger'],
    ['fabric sample', 'stofprøve|stofprøver|stofproeve|stofproever|stofprøvepakke|stoffmuster|stoffprobe|stoffproben'],
    ['spare parts', 'reservedel|reservedele|ersatzteil|ersatzteile'],
    ['furniture', 'møbel|møbler|moebel|moebler|möbel'],
    ['smoked oak', 'røget eg|roeget eg|geräucherte eiche|geraeucherte eiche|geräuchert eiche|geraeuchert eiche|räuchereiche|raeuchereiche'],
    ['oak', 'eg|egetræ|egetrae|eiche|eichenholz|eichen'],
    ['stainless steel', 'rustfrit stål|rustfri stål|rustfrit staal|rustfri staal|rustfrit|rustfri|edelstahl|rostfreier stahl'],
    ['steel', 'stål|staal|stahl'],
    ['brass', 'messing'],
    ['wood', 'træ|trae|holz'],
    ['leather', 'læder|laeder|leder'],
    ['ceramic', 'keramik|keramisk|keramiske|keramisch'],
    ['black', 'sort|sorte|schwarz|schwarze|schwarzer|schwarzes'],
    ['white', 'hvid|hvide|weiß|weiss|weiße|weisse|weisser|weißes'],
    ['blue', 'blå|blaa|blau|blaue'],
    ['green', 'grøn|grønt|grønne|groen|groent|groenne|grün|gruen|grüne|gruene'],
    ['red', 'rød|rødt|røde|roed|roedt|roede|rot|rote'],
    ['grey', 'grå|graa|grau|graue'],
    ['round', 'rund|runde|rundt|runder|rundes'],
    ['rectangular', 'rektangulær|rektangulaer|rektangulært|rektangulære|rechteckig|rechteckiger|rechteckige|rechteckiges'],
    ['square', 'kvadratisk|kvadratiske|quadratisch|quadratische'],
    ['small', 'lille|lilles|klein|kleine|kleiner|kleines'],
    ['low', 'lav|lave|lavt|niedrig|niedrige'],
    ['tall', 'høj|høje|højt|hoej|hoeje|hoejt|hoch|hohe']
  ];
  const fold = (value) => value.toLocaleLowerCase().replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const aliases = new Map();
  groups.forEach(([target, words]) => words.split('|').forEach((word) => aliases.set(fold(word), target)));
  const longest = Math.max(...[...aliases.keys()].map((key) => key.split(' ').length));
  const englishWords = new Set(groups.flatMap(([target]) => target.split(/[ -]/)));
  const connectors = new Set(['i', 'af', 'med', 'aus', 'mit', 'in', 'en', 'et', 'ein', 'eine']);

  function translate(value, predictive = true) {
    const original = value.trim();
    if (!original || /[:()"*]|(?:^|\s)(?:AND|OR|NOT)(?:\s|$)/.test(original)) return original;
    const tokens = original.split(/\s+/);
    const normalized = tokens.map(fold);
    const output = [];
    let changed = false;
    for (let index = 0; index < tokens.length;) {
      let match;
      let length = Math.min(longest, tokens.length - index);
      for (; length > 0; length -= 1) {
        const phrase = normalized.slice(index, index + length).join(' ');
        let target = aliases.get(phrase);
        if (!target && predictive && index + length === tokens.length && phrase.length >= 3 && ![...englishWords].some((word) => word.startsWith(phrase))) {
          const candidates = new Set([...aliases].filter(([alias]) => alias.startsWith(phrase)).map(([, canonical]) => canonical));
          if (candidates.size === 1) target = [...candidates][0];
        }
        if (target) {
          match = target;
          break;
        }
      }
      if (match) {
        output.push({ text: match, translated: true });
        changed = true;
        index += length;
      } else {
        output.push({ text: tokens[index], translated: false });
        index += 1;
      }
    }
    return changed ? output.filter((part) => part.translated || !connectors.has(fold(part.text))).map((part) => part.text).join(' ') : original;
  }

  function replaceText(root, from, to) {
    if (!from || from === to) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) walker.currentNode.textContent = walker.currentNode.textContent.split(from).join(to);
  }

  const current = new URL(window.location.href);
  const query = current.searchParams.get('q') || '';
  const saved = current.searchParams.get('moebe_q');
  const original = saved && translate(saved) === query ? saved : null;
  if (/\/search\/?$/.test(current.pathname) && query && !current.searchParams.has('section_id') && !current.searchParams.has('sections')) {
    const translated = translate(query);
    if (translated !== query) {
      current.searchParams.set('q', translated);
      current.searchParams.set('moebe_q', query);
      window.location.replace(current.href);
    } else if (original) {
      document.querySelectorAll('moebe-search [data-search-input]').forEach((input) => { input.value = original; });
      document.querySelectorAll('.search-content .section-header p').forEach((node) => replaceText(node, query, original));
    }
  }

  document.addEventListener('formdata', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    const action = new URL(event.target.action, window.location.href);
    if (action.origin !== window.location.origin || !/\/search\/?$/.test(action.pathname)) return;
    const entered = event.formData.get('q');
    if (typeof entered !== 'string') return;
    const translated = translate(entered);
    event.formData.set('q', translated);
    if (translated !== entered.trim()) event.formData.set('moebe_q', entered.trim());
    else if (original && translated === query) event.formData.set('moebe_q', original);
    else event.formData.delete('moebe_q');
  }, true);

  window.MoebeSearchLanguage = { translate, replaceText, aliasCount: aliases.size };
})();

(() => {
  class MoebeSearch extends HTMLElement {
    connectedCallback() {
      if (this.input) return;
      this.input = this.querySelector('[data-search-input]');
      this.panel = this.querySelector('[data-search-panel]');
      this.discovery = this.querySelector('[data-search-discovery]');
      this.results = this.querySelector('[data-search-results]');
      this.status = this.querySelector('[data-search-status]');
      this.clearButton = this.querySelector('[data-search-clear]');
      this.isHeader = this.dataset.context === 'header';
      if (this.isHeader) {
        document.querySelectorAll('.js-search-header').forEach((trigger) => {
          trigger.setAttribute('aria-controls', this.id);
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-expanded', 'false');
        });
      }
      this.cache = new Map();
      this.sequence = 0;
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      document.addEventListener('predictive-search:open', (event) => {
        if (event.detail?.context === this.dataset.context) this.activate();
      }, options);
      document.addEventListener('predictive-search:close', () => this.close(), options);
      this.input.addEventListener('focus', () => {
        if (!this.active) this.activate();
      }, options);
      this.input.addEventListener('input', () => this.changed(), options);
      this.input.addEventListener('search', () => this.changed(), options);
      this.clearButton.addEventListener('click', () => {
        this.input.value = '';
        this.changed();
        this.input.focus();
      }, options);
      this.querySelector('[data-search-close]')?.addEventListener('click', () => this.close(), options);
      this.querySelector('[data-screen]').addEventListener('click', () => this.close(), options);
      document.addEventListener('click', (event) => {
        if (!this.isHeader || !this.active || this.contains(event.target) || event.target.closest('.js-search-header')) return;
        this.close(false);
      }, options);
      this.querySelector('form').addEventListener('submit', (event) => {
        if (!this.input.value.trim()) {
          event.preventDefault();
          this.input.focus();
        }
      }, options);
      document.addEventListener('keydown', (event) => this.keydown(event), options);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget) && event.relatedTarget && !event.relatedTarget.closest('.js-search-header')) this.close(false);
      }, options);
      window.addEventListener('resize', () => this.updateHeight(), options);
      window.visualViewport?.addEventListener('resize', () => this.updateHeight(), options);
    }

    disconnectedCallback() {
      this.cancel();
      this.listeners?.abort();
      this.restoreBackground();
    }

    activate() {
      if (this.active) return;
      this.active = true;
      this.returnFocus = document.activeElement;
      this.classList.add('is-active');
      this.panel.hidden = false;
      if (this.isHeader) document.querySelectorAll('.js-search-header').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
      if (this.isHeader) {
        document.querySelector('.site-header__search-container')?.classList.add('is-active');
      }
      this.changed();
      requestAnimationFrame(() => {
        if (!this.active) return;
        this.input.focus();
        this.updateHeight();
      });
    }

    lockBackground() {
      this.background = [];
      let node = this;
      while (node.parentElement && node.parentElement !== document.documentElement) {
        for (const sibling of node.parentElement.children) {
          if (sibling !== node && !sibling.inert && !['SCRIPT', 'STYLE', 'LINK'].includes(sibling.tagName)) {
            sibling.inert = true;
            this.background.push(sibling);
          }
        }
        node = node.parentElement;
        if (node === document.body) break;
      }
    }

    restoreBackground() {
      this.background?.forEach((node) => { node.inert = false; });
      this.background = [];
    }

    updateHeight() {
      if (!this.active) return;
      const top = this.panel.getBoundingClientRect().top;
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      this.panel.style.maxHeight = Math.max(0, bottom - top - 16) + 'px';
    }

    cancel() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.sequence += 1;
      this.results?.removeAttribute('aria-busy');
    }

    changed() {
      this.cancel();
      const term = this.input.value.trim();
      this.clearButton.hidden = !term;
      this.results.innerHTML = '';
      this.results.hidden = true;
      this.discovery.hidden = Boolean(term);
      this.status.textContent = '';
      if (!term || this.dataset.enabled === 'false') {
        this.discovery.hidden = false;
        return;
      }
      const sequence = this.sequence;
      this.results.hidden = false;
      this.results.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      this.timer = setTimeout(() => this.search(term, sequence), 250);
    }

    async search(term, sequence) {
      const searchTerm = window.MoebeSearchLanguage.translate(term, true);
      try {
        let markup = this.cache.get(term);
        if (!markup) {
          this.request = new AbortController();
          const params = Object.entries({
            q: searchTerm,
            'resources[type]': 'product,collection',
            'resources[limit]': '4',
            'resources[limit_scope]': 'each',
            'resources[options][unavailable_products]': 'last',
            section_id: 'search-results'
          }).map(([key, value]) => key + '=' + encodeURIComponent(value)).join('&');
          const response = await fetch(this.dataset.endpoint + '?' + params, { signal: this.request.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const text = await response.text();
          const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-results');
          if (!section) throw new Error('Search section missing');
          markup = section.innerHTML;
          if (this.cache.size >= 20) this.cache.delete(this.cache.keys().next().value);
          this.cache.set(term, markup);
        }
        if (!this.active || sequence !== this.sequence || this.input.value.trim() !== term) return;
        this.results.innerHTML = markup;
        if (searchTerm !== term) {
          this.results.querySelectorAll('.moebe-search__view-all span, .moebe-search__message').forEach((node) => {
            window.MoebeSearchLanguage.replaceText(node, searchTerm, term);
          });
          this.results.querySelectorAll('.moebe-search__view-all').forEach((link) => {
            const url = new URL(link.href, window.location.href);
            url.searchParams.set('moebe_q', term);
            link.href = url.href;
          });
        }
        this.results.removeAttribute('aria-busy');
        const summary = this.results.querySelector('[data-search-summary]');
        this.status.textContent = summary?.dataset.searchSummary || '';
        this.updateHeight();
        window.MoebeCRO?.searchResults(this, searchTerm !== term);
      } catch (error) {
        if (error.name === 'AbortError' || sequence !== this.sequence || !this.active) return;
        this.results.innerHTML = '';
        this.results.removeAttribute('aria-busy');
        const message = document.createElement('p');
        message.className = 'moebe-search__message';
        message.textContent = this.dataset.error;
        const button = document.createElement('button');
        button.type = 'submit';
        button.className = 'moebe-search__view-all';
        button.textContent = this.dataset.submit;
        this.results.append(message, button);
        this.status.textContent = this.dataset.error;
      }
    }

    keydown(event) {
      if (!this.active || (!this.isHeader && !this.contains(event.target))) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      const links = [...this.panel.querySelectorAll('a[href], button')].filter((node) => node.getClientRects().length);
      if (['ArrowDown', 'ArrowUp'].includes(event.key) && (event.target === this.input || links.includes(event.target))) {
        if (!links.length) return;
        event.preventDefault();
        const index = links.indexOf(event.target);
        const next = event.key === 'ArrowDown' ? index + 1 : (index === -1 ? links.length - 1 : index - 1);
        if (next < 0 || next >= links.length) this.input.focus();
        else links[next].focus();
      }
      if (event.key === 'Tab' && this.isHeader && this.getAttribute('aria-modal') === 'true') {
        const controls = [...this.querySelectorAll('input:not([type="hidden"]), button, a[href]')]
          .filter((node) => !node.disabled && node.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && event.target === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && event.target === last) {
          event.preventDefault();
          first?.focus();
        }
      }
    }

    close(restoreFocus = true) {
      if (!this.active) return;
      this.active = false;
      this.cancel();
      this.panel.hidden = true;
      if (this.isHeader) document.querySelectorAll('.js-search-header').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      this.classList.remove('is-active');
      this.removeAttribute('aria-modal');
      this.restoreBackground();
      if (this.isHeader) {
        document.querySelector('.site-header__search-container')?.classList.remove('is-active');
        document.body.classList.remove('predictive-overflow-hidden');
        document.dispatchEvent(new CustomEvent('predictive-search:close-all'));
      }
      this.status.textContent = '';
      if (restoreFocus) {
        requestAnimationFrame(() => {
          if (this.active) return;
          const target = this.isHeader ? this.returnFocus : this.querySelector('[data-search-input]');
          if (target?.isConnected && target !== this.input) target.focus();
          else if (!this.isHeader) this.querySelector('[type="submit"]').focus();
        });
      }
    }
  }
  customElements.define('moebe-search', MoebeSearch);
})();

